import { createSlice } from "@reduxjs/toolkit";
import { fetchDamages } from "./thunk";

interface FetchDamageState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: FetchDamageState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const DailyStateSlice = createSlice({
  name: "Damage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDamages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDamages.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchDamages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Draft RFQ List";
      });
  },
});

export default DailyStateSlice.reducer;
